<template>
  <div class="ui-tip" v-if="showTip">
    <div class="ui-tip-l">
      <img src="https://m.360buyimg.com/jrqb/jfs/t29095/114/265922735/753/4ae71817/5becfc5eN6b44357e.png" />
    </div>
    <div class="ui-tip-c"><span>{{content}}</span></div>
    <div class="ui-tip-r" @click="close">
      <img src="https://m.360buyimg.com/jrqb/jfs/t27862/250/1788261838/390/415e64de/5becfc5eN869b7a06.png"/>
    </div>
  </div>
</template>
<script>
import { isTimeOverdue, setTimeOverdue } from '@/util/storageDateLimt';

export default {
  name: 'Tip',
  data() {
    return {
      showTip: true
    }
  },
  components: {},
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  methods: {
    close() {
      if (this.showTip) {
        this.showTip = false;
        setTimeOverdue('everyday_tip');
      }
    }
  },
  mounted() {
    this.showTip = isTimeOverdue('everyday_tip');
  },
  destroyed() {
    this.$refs.kplIns = null;
  }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.ui-tip {
  // position: absolute;
  // top: 0;
  // left: 0;
  z-index: 9;
  width: 100%;
  padding: $rem16 0;
  background: rgba($color: #FDEED8, $alpha: 0.8);
  display: flex;
  align-content: center;
  align-items: center;
  .ui-tip-l {
    height: 100%;
    padding: $rem0 $rem0 $rem0 $rem24;
    line-height: $rem24;
    img {
      // position: absolute;
      // left: $rem24;
      // top: $rem16;
      width: $rem24;
    }
  }
  .ui-tip-c {
    flex: 1;
    height: 100%;
    line-height: $rem28;
    font-size: $rem22;
    font-family: PingFangSC-Regular;
    color: #603B07;
    display: flex;
    align-items: center;
    padding: 0 $rem20;
    span {
      text-align: justify;
    }
  }
  .ui-tip-r {
    // width: $rem70;
    padding: 0 $rem30 0 $rem0;
    line-height: $rem24;
    img {
      // position: absolute;
      // right: $rem24;
      // top: $rem16;
      width: $rem24;
    }
  }
}
</style>
